module.exports = __webpack_public_path__ + "img/landliebe-grundriss.ee66c847.jpg";